export default {
  name: "Tên",
  tel: "Điện thoại",
  save: "Lưu",
  confirm: "Xác nhận",
  cancel: "Hủy",
  delete: "Xóa",
  complete: "Hoàn thành",
  loading: "Đang tải...",
  telEmpty: "Vui lòng nhập số điện thoại",
  nameEmpty: "Vui lòng nhập tên",
  nameInvalid: "Vui lòng nhập tên hợp lệ",
  confirmDelete: "Bạn có chắc chắn muốn xóa không?",
  telInvalid: "Vui lòng nhập số điện thoại hợp lệ",
  SelectYearMonthDay: "Chọn Năm, Tháng, Ngày",
  vanCalendar: {
    end: "Kết thúc",
    start: "Bắt đầu",
    title: "Chọn ngày",
    confirm: "Xác nhận",
    startEnd: "Bắt đầu/Kết thúc",
    weekdays: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
    monthTitle: (year, month) => `Tháng ${month} năm ${year}`,
    rangePrompt: (maxRange) => `Không thể chọn quá ${maxRange} ngày`,
  },
  vanCascader: {
    select: "Vui lòng chọn",
  },
  vanContactCard: {
    addText: "Thêm liên hệ",
  },
  vanContactList: {
    addText: "Thêm liên hệ mới",
  },
  vanPagination: {
    prev: "Trang trước",
    next: "Trang sau",
  },
  vanPullRefresh: {
    pulling: "Kéo xuống để làm mới...",
    loosing: "Thả ra để làm mới...",
  },
  vanSubmitBar: {
    label: "Tổng cộng:",
  },
  vanCoupon: {
    unlimited: "Không giới hạn sử dụng",
    discount: (discount) => `Giảm ${discount}%`,
    condition: (condition) => `Áp dụng cho đơn từ ${condition}`,
  },
  vanCouponCell: {
    title: "Phiếu giảm giá",
    tips: "Không có phiếu khả dụng",
    count: (count) => `${count} phiếu khả dụng`,
  },
  vanCouponList: {
    empty: "Không có phiếu giảm giá",
    exchange: "Đổi",
    close: "Không sử dụng",
    enable: "Khả dụng",
    disabled: "Không khả dụng",
    placeholder: "Nhập mã giảm giá",
  },
  vanAddressEdit: {
    area: "Khu vực",
    postal: "Mã bưu chính",
    areaEmpty: "Vui lòng chọn khu vực",
    addressEmpty: "Vui lòng nhập địa chỉ chi tiết",
    postalEmpty: "Mã bưu chính không hợp lệ",
    defaultAddress: "Đặt làm địa chỉ mặc định",
    telPlaceholder: "Số điện thoại người nhận",
    namePlaceholder: "Tên người nhận",
    areaPlaceholder: "Chọn Tỉnh / Thành phố / Quận",
  },
  vanAddressEditDetail: {
    label: "Địa chỉ chi tiết",
    placeholder: "Số nhà, tên đường, tầng, số phòng",
  },
  vanAddressList: {
    add: "Thêm địa chỉ mới",
  },
  realName: "Họ tên thật",
  idCard: "CMND/CCCD",

  unionManagement: {
    GuildRegistration: "Đăng ký Guild",
    ApplicantID: "ID Người đăng ký",
    GuildName: "Tên Guild",
    PleaseGuildName: "Vui lòng nhập tên guild",
    PleaseGuildID: "Vui lòng nhập ID Guild",
    PleaseInformation: "Vui lòng nhập thông tin liên hệ",
    PlatformsWith: "Các nền tảng đã hợp tác",
    ListOfplatforms: "Liệt kê các nền tảng đã hợp tác",
    GuildSize: "Quy mô Guild",
    EstimatedNumber: "Số lượng streamer dự kiến",
    Notes: "Lưu ý: Liên hệ trưởng guild hoặc thành viên để lấy ID guild",
    Submit: "Gửi",
    SubmitSuccess: "Gửi thành công",
    MyGuild: "Guild của tôi",
    VoiceHallOnboarding: "Đăng ký Phòng Giọng nói",
    VoiceHallName: "Tên Phòng Giọng nói",
    PleaseVoiceHallName: "Vui lòng nhập tên phòng giọng nói",
    WhatsApp: "WhatsApp",
    PleaseContactInfo: "Vui lòng nhập thông tin liên hệ",
    PlatformsCollaborated: "Các nền tảng đã hợp tác",
    ListPlatformsCollaborated: "Liệt kê các nền tảng đã hợp tác",
    VoiceHallScale: "Quy mô Phòng Giọng nói",
    EstimatedAnchors: "Số lượng streamer dự kiến của phòng giọng nói",
    CertificationType: "Loại Chứng nhận",
    VoiceHall: "Phòng Giọng nói",
    VoiceGuild: "Guild Giọng nói",
    HostName: "Tên streamer",
    GuildJoinDate: "Ngày tham gia Guild",
    TotalMembers: "Tổng số thành viên Guild",
    TotalPeople: "Tổng số người",
    DataDetails: "Chi tiết dữ liệu",
    PleaseHostID: "Vui lòng nhập ID streamer",
    Search: "Tìm kiếm",
    KickOut: "Kick",
    NoData: "Không có dữ liệu",

    InformationData: "Thông tin dữ liệu",
    Name: "Họ tên",
    PleaseID: "Vui lòng nhập đúng tên trên CMND/CCCD",
    IdentityCard: "CMND/CCCD",
    YourIDnumber: "Số CMND/CCCD của bạn",
    IDPhoto: "Ảnh CMND/CCCD",
    PleasePhoto: "Vui lòng tải lên ảnh CMND/CCCD",
    FrontofID: "Mặt trước CMND/CCCD",
    BackofID: "Mặt sau CMND/CCCD",
    NotePlease:
      "Lưu ý: Vui lòng tải lên ảnh cầm CMND/CCCD, khuôn mặt rõ ràng không che chắn, ảnh và số CMND/CCCD phải rõ ràng",
    Country: "Quốc gia",
    SelectCountryorRegion: "Chọn Quốc gia/Khu vực",
    BankName: "Tên ngân hàng",
    Pleasebankname: "Vui lòng nhập tên ngân hàng",
    BankCardNumber: "Số tài khoản ngân hàng",
    Pleasebankcardnumber: "Vui lòng nhập số tài khoản",
    BankCardHolder: "Chủ tài khoản",
    Pleasebankcardholder: "Vui lòng nhập tên chủ tài khoản",
    PhoneNumber: "Số điện thoại",
    Enterphonenumber: "Nhập số điện thoại hợp lệ",
    Notebankaccount: "Lưu ý: Vui lòng nhập số điện thoại đăng ký ngân hàng",
    WhatsAppContactInformation: "Thông tin liên hệ WhatsApp",
    Pleaseownnumber: "Vui lòng nhập số điện thoại của bạn",
    Notecollaborationmatters:
      "Lưu ý: Số WhatsApp của guild sẽ được sử dụng làm phương thức liên hệ duy nhất cho các vấn đề hợp tác",
    Email: "Email",
    Pleaseemailaddress: "Vui lòng nhập email của bạn",
    Notematters:
      "Lưu ý: Email của guild sẽ được sử dụng làm phương thức liên hệ duy nhất cho các vấn đề hợp tác",

    SpecialGiftDetails: "Chi tiết quà tặng đặc biệt",
    CurrentDate: "Ngày hiện tại",
    GoldCoinTransactions: "Lợi nhuận may mắn của đậu vàng",
    LiveStreamingDuration: "Thời gian phát sóng",
    GoldBeanEarnings: "Thu nhập đậu vàng",
    EffectiveDays: "Số ngày hiệu lực",
    WarningCount: "Số lần cảnh báo",

    give: "Tặng",
    pleasewait: "Đang xử lý, vui lòng đợi...",

    JoinGuild: "Tham gia Guild",
    GuildId: "ID Guild",
    PlaceholderGuildId: "Vui lòng nhập ID Guild",

    InvitationCode: "Mã mời",

    noMore: "Không còn nữa",

    Recommendation: "Người giới thiệu (tùy chọn)",
    nightLiveTime: "Thời gian đặc biệt",

    // Trang Dữ Liệu Guild
    GuildIncome: "Thu Nhập Guild",
    AnchorIncome: "Thu Nhập Anchor",
    EffectiveLive: "Phát Sóng Hiệu Quả",
    EffectiveDays: "Ngày Hiệu Quả",
    Income: "Thu Nhập",
    Duration: "Thời Lượng",
  },

  familyMain: {
    anchorList: "Danh sách Anchor",
    anchorData: "Dữ liệu Anchor",
    micTime: "Thời gian Mic",
    micTimeData: "Dữ liệu thời gian Mic",
    beansDetail: "Chi tiết Đậu vàng",
    beansDetailData: "Dữ liệu chi tiết Đậu vàng",
    withdrawDetail: "Chi tiết rút tiền",
    withdrawDetailData: "Dữ liệu chi tiết rút tiền",
    roomData: "Dữ liệu phòng",
    roomDataData: "Dữ liệu phòng",
    distributeBeans: "Phân phối Đậu vàng",
    distributeBeansData: "Dữ liệu phân phối Đậu vàng",
    privateShareStats: "Thống kê tin nhắn/chia sẻ",
    privateShareStatsData: "Dữ liệu thống kê tin nhắn/chia sẻ",
    roomTurnover: "Doanh thu phòng",
    roomTurnoverData: "Dữ liệu doanh thu phòng",
    incomeRecord: "Lịch sử thu nhập",
    incomeRecordData: "Dữ liệu lịch sử thu nhập",
    knapsackGiftDetail: "Chi tiết quà túi đồ",
    knapsackGiftData: "Dữ liệu quà túi đồ",
    roomFilterTitle: "Bộ lọc phòng",
    roomFilterConfirm: "Hoàn tất",
    allRooms: "Tất cả phòng",
  },
  anchorList: {
    countLabel: "【{count} streamer】",
    searchPlaceholder: "Nhập ID streamer",
    search: "Tìm kiếm",
    joinTimeLabel: "Thời gian tham gia：",
    noData: "Không có dữ liệu",
    nickNameFallback: "Tên streamer",
    invalidUserId: "Vui lòng nhập ID là số",
  },

  salaryMain: {
    searchPlaceholder: "Nhập ID anchor để tìm kiếm",
    dateSelect: "Chọn ngày",
    byDay: "Theo ngày",
    byRange: "Theo khoảng",
    searchTime: "Thời gian tìm kiếm",
    to: " đến ",
    dataSummary: "Tổng hợp dữ liệu",
    totalMicTime: "Tổng thời gian Mic",
    totalHeartGiftTurnover: "Tổng đậu vàng may mắn",
    totalLuxuryGiftTurnover: "Tổng đậu vàng",
    member: "Thành viên",
    anchorProfile: "Hồ sơ Anchor",
    micTime: "Thời gian Mic",
    heartGiftTurnover: "Đậu vàng may mắn",
    luxuryGiftTurnover: "Tổng đậu vàng",
    roomNumber: "Số phòng",
    pleaseSelectTime: "Chọn thời gian",
    pleaseEnterNumber: "Vui lòng nhập số",
    selectAll: "Chọn tất cả",
    minute: "phút",
    second: "giây",
  },

  anchorCenter: {
    todayLiveData: "Dữ liệu livestream hôm nay",
    time: "Thời gian",
    duration: "Thời lượng",
    income: "Thu nhập đậu vàng may mắn",
    giftRecord: "Lịch sử quà tặng",
    withdraw: "Rút tiền",
    tipsUpdate: "Lưu ý: Dữ liệu trong ngày được cập nhật mỗi phút",
    overallData: "Dữ liệu tổng thể",
    totalDays: "Tổng số ngày",
    totalDuration: "Tổng thời lượng",
    totalTurnover: "Tổng đậu vàng may mắn",
    totalIncome: "Tổng lương cơ bản",
    totalBeans: "Tổng đậu vàng",
    luckyBeans: "Đậu vàng may mắn",
    specialBeans: "Đậu vàng hiệu ứng",
    baseSalary: "Lương cơ bản",
    totalIncomeLabel: "Tổng thu nhập",
  },

  micTime: {
    searchPlaceholder: "Nhập ID anchor",
    search: "Tìm kiếm",
    dateSelect: "Chọn ngày",
    today: "Hôm nay",
    thisWeek: "Tuần này",
    lastWeek: "Tuần trước",
    totalMicTime: "Tổng thời gian Mic",
    date: "Ngày",
    anchorInfo: "Thông tin Anchor",
    micTime: "Thời gian Mic",
    pleaseSelectTime: "Chọn thời gian",
    selectAll: "Chọn tất cả",
    minute: "phút",
    second: "giây",
  },

  anchroOtayonii: {
    dateSelect: "Chọn ngày",
    byDay: "Theo ngày",
    byRange: "Theo khoảng",
    searchTime: "Thời gian tìm kiếm",
    to: " đến ",
    dataSummary: "Tổng hợp dữ liệu",
    totalLuckyGift: "Tổng quà Lucky",
    totalSpecialGift: "Tổng quà Special",
    totalKnapsackGift: "Tổng quà Knapsack",
    anchorInfo: "Thông tin Anchor",
    luckyGift: "Quà Lucky",
    specialGift: "Quà Special",
    knapsackGift: "Quà Knapsack",
    pleaseSelectTime: "Chọn thời gian",
    selectAll: "Chọn tất cả",
  },

  roomCm: {
    dateSelect: "Chọn ngày",
    today: "Hôm nay",
    thisWeek: "Tuần này",
    lastWeek: "Tuần trước",
    dataSummary: "Tổng hợp dữ liệu",
    totalTurnover: "Tổng đậu vàng may mắn",
    totalTurnoverBeans: "Tổng đậu vàng",
    date: "Ngày",
    heartGiftTurnover: "Đậu vàng may mắn",
    specialGiftTurnover: "Tổng đậu vàng",
    room: "Phòng",
    pleaseSelectTime: "Chọn thời gian",
    selectAll: "Chọn tất cả",
    minute: "phút",
    second: "giây",
  },

  weekProfit: {
    dateSelect: "Chọn ngày",
    time: "Thời gian",
    type: "Loại",
    beans: "Đậu",
    pleaseSelectTime: "Chọn thời gian",
  },

  withdrawRecord: {
    withdrawAmount: "Số tiền rút",
    withdrawStatus: "Trạng thái rút tiền",
    NoData: "Không có dữ liệu",

    UnderReview: "Đang xét duyệt",
    Processing: "Đang xử lý",
    Completed: "Đã hoàn thành",
    Rejected: "Đã từ chối",
    Failed: "Thất bại",

    Pending: "Đang chờ",
    Success: "Thành công",
    NoMore: "Không còn nữa",
    PleaseWait: "Đang xử lý, vui lòng đợi...",
    PleaseSelect: "Vui lòng chọn",
    Date: "Ngày",
    RealAmount: "Số tiền thực nhận",
    Fee: "Phí",
    Status: "Trạng thái",
    Remark: "Ghi chú",
  },

  coinManagement: {
    myGoldenbeans: "Đậu vàng của tôi",
    Withdraw: "Rút tiền",
    ExchangeGoldCoins: "Đổi xu",
    HostInformation: "Thông tin streamer",
    WithdrawalCurrency: "Loại tiền rút",
    SelectWithdrawalCurrency: "Vui lòng chọn loại tiền rút",
    FiatCurrency: "Tiền pháp định",
    PleaseSelectWithdrawalCurrency: "Vui lòng chọn loại tiền rút",
    tips: "Lưu ý:",
    tipsp0: "1. Tỷ lệ rút tiền: 10.000 đậu vàng = 0,5 USD",
    tipsp1:
      "2. Mức tối thiểu rút: 100,000 đậu vàng, chỉ có thể rút theo bội số của 10,000",
    tipsp2:
      "3. Liên kết tài khoản rút tiền. Do đa dạng phương thức thanh toán quốc tế và không có giấy tờ cố định, hệ thống cần nhiều loại xác thực khi thêm tài khoản trưởng gia tộc [phương thức thanh toán cụ thể tùy tình hình hiện tại]",
    tipsp3: "4. Đã xác minh danh tính chưa",
    tipsp4: "5. Liên kết số điện thoại",
    tipsp5:
      "Nếu chưa hoàn thành bất kỳ bước nào trên, sẽ không thể rút tiền. Trang sẽ thông báo hoặc hướng dẫn người dùng",
    tipsp6: "① Chỉ thông báo",
    tipsp7:
      "② Chuyển đến trang liên kết số điện thoại, sau khi hoàn thành sẽ quay lại",
    tipsp8:
      "③ Chuyển đến trang xác minh danh tính, sau khi hoàn thành sẽ quay lại",
    tipsp9:
      "④ Chuyển đến trang liên kết tài khoản, sau khi hoàn thành sẽ quay lại",
    tipsp10: "3. Rút tiền sẽ có phí, phí sẽ khác nhau tùy theo kênh rút tiền",

    tipsp11: "1. Tỷ lệ quy đổi: 1000 đậu vàng = 500 xu vàng",
    tipsp12: "2. Tối thiểu 5000 đậu vàng để đổi, phải là bội số của 1000",
    tipsp13:
      "3. Sau khi quy đổi thành công không thể hủy, vui lòng cân nhắc kỹ",

    num: "Số lượng",
    Custom: "Tùy chỉnh",
    PleaseEnter: "Vui lòng nhập",
    Redeem: "Đổi",
    SelectType: "Chọn loại",
    GoldBeans: "Đậu vàng",
    GoldCoin: "Xu",
    WithdrawalAmount: "Số tiền rút",
    PleaseNum: "Nhập số xu muốn rút",
    All: "Tất cả",
    Withdraw: "Rút tiền",

    Incomedetails: "Chi tiết thu nhập",
    Expensedetails: "Chi tiết chi tiêu",
    Nobeans: "Không có đậu vàng để đổi",

    balance: "Số dư",

    Record: "Lịch sử giao dịch",
    WithdrawalRecord: "Lịch sử rút tiền",
  },

  contactUs: {
    Officialcustomerservice: "Dịch vụ khách hàng chính thức",
    ContactUs: "Liên hệ chúng tôi",
    Issueofguild: "Vấn đề về Guild",
  },

  myInvitation: {
    MyGoldBeans: "Đậu vàng của tôi",
    Share: "Chia sẻ mời thêm bạn",
    CopyLink: "Sao chép liên kết",
    GoldCoinEarnedToday: "Xu nhận được hôm nay",
    TotalGoldCoin: "Tổng xu",
    tips: "Mời người dùng mới nạp tiền sẽ nhận được 1% xu thưởng",
    tips2: "Không thể liên kết sau 48 giờ đăng ký",
    MyInvitations: "Lời mời của tôi",
    BillingDetails: "Chi tiết hóa đơn",
    Total: "Tổng cộng",
    People: "người",
    GoldCoinGiven: "Xu đã tặng",
    GiveGoldCoin: "Tặng thêm+",
  },

  userMisconduct: {
    title1: "Vi phạm nội dung I",
    p1: "1. Hiển thị hoặc truyền bá nội dung bị cấm:",
    p2: "Bao gồm nội dung khiêu dâm, thô tục, bạo lực hoặc phân biệt chủng tộc trong chat riêng, live stream hoặc các tính năng khác của Rain Live.",
    p3: "2. Lan truyền phát ngôn thù địch:",
    p4: "Cấm phát ngôn thù địch về tôn giáo, chủng tộc, chính trị hoặc quốc tịch.",
    p5: "3. Quảng cáo hoặc lôi kéo:",
    p6: "Cấm mời người dùng tham gia các ứng dụng hoặc nền tảng khác thông qua live stream, chat riêng hoặc bình luận đã duyệt.",
    title2: "Hậu quả",
    p7: "Tài khoản, thiết bị hoặc địa chỉ IP liên quan đến vi phạm có thể bị cấm",

    title3: "Vi phạm nội dung II",
    p8: "1. Chia sẻ thông tin cá nhân:",
    p9: "Cấm chia sẻ thông tin cá nhân như số điện thoại, ID tài khoản, tài khoản Facebook, ảnh, v.v. thông qua live stream, bình luận hoặc chat riêng của Rain Live.",
    p10: "2. Lạm dụng tài khoản:",
    p11: "Cấm cung cấp, cho thuê hoặc bán tài khoản Rain Live.",
    p12: "3. Sử dụng thông tin cá nhân:",
    p13: "Cấm sử dụng hoặc phát tán thông tin cá nhân (ảnh, biệt danh, v.v.) của người dùng mà không được sự đồng ý để trục lợi hoặc tấn công ác ý",
    title4: "Hậu quả",
    p14: "Người dùng vi phạm sẽ bị cấm vĩnh viễn",
  },

  landingPage: {
    info1: "Cộng đồng Rain Live",
    info2: "Mua sắm nội bộ Apl",
    item1: "45K đánh giá",
    item2: "Tải xuống",
    item3: "Cấp độ 3+",
    btn: "Tải xuống",
    title: "Về Rain Live",
    content:
      "Rain Live là ứng dụng live stream thân thiện dành cho mọi người, bao gồm voice, video, giải trí, game, v.v. Nền tảng quy tụ các streamer xinh đẹp, là nền tảng live stream có chiều sâu và nội dung. PK gay cấn, sự kiện liên tục, quà tặng độc đáo, trải nghiệm đẳng cấp hoàng gia.",
    tips: "Rain Live đứng đầu danh sách ứng dụng xã hội miễn phí phổ biến.",
  },

  equityLevel: {
    Experience: "Điểm kinh nghiệm",
    Level: "Cấp độ hiện tại",
    Berikutnya: "Còn lại để lên cấp",
    title1: "Đặc quyền cấp độ",
    desc1:
      "Cấp độ càng cao, biểu tượng càng sang trọng, càng dễ được streamer yêu thích chú ý",
    title2: "Cách lên cấp",
    desc2:
      "1. Cấp độ người dùng phụ thuộc vào số điểm kinh nghiệm từ việc tặng quà",
    desc3:
      "2. Bạn có thể nhận điểm kinh nghiệm để lên cấp bằng cách tặng quà hàng ngày",
    desc4: "3. Quà may mắn, mỗi 1 xu tiêu = 1 điểm kinh nghiệm",
    desc5: "4. Quà đặc biệt, mỗi 1 xu tiêu = 10 điểm kinh nghiệm",
    title3: "Đặc quyền cấp độ",
    desc6:
      "Cấp độ càng cao, biểu tượng càng sang trọng, càng dễ được người dùng chú ý",
    title4: "Cách lên cấp",
    desc7:
      "1. Cấp độ streamer phụ thuộc vào số điểm kinh nghiệm từ việc nhận quà",
    desc8:
      "2. Bạn có thể nhận điểm kinh nghiệm để lên cấp thông qua số lượng quà nhận được hàng ngày",

    title6: "Cấp độ người dùng",
    title7: "Cấp độ",
    title8: "Huy hiệu cấp độ",
    title9: "Cấp độ streamer",
    title10: "Tổng điểm kinh nghiệm",

    LevelDescription: "Mô tả cấp độ",
  },

  applyJoin: {
    tips1: "Vui lòng nhập tài khoản WhatsApp của bạn",
    title2: "Yêu cầu ảnh",
    tips2: "Vui lòng chụp ảnh khuôn mặt và nửa thân trên, tạo dáng tay như mèo",
    tips3: "Ảnh này sẽ được sử dụng để công ty xét duyệt và sẽ được bảo mật.",
    tips4: "Ảnh phải là của chính bạn.",
    title3: "Yêu cầu video",
    tops5: "Video phải là của chính bạn.",
    tips6: "Thời lượng video từ 10 đến 20 giây.",
    status1: "Gửi xét duyệt",
    status2: "Đang xét duyệt",
    status3: "Xét duyệt thành công",
    status4: "Xét duyệt thất bại",
    LiveMode: "Chế độ live",
    Video: "Video",
    Voice: "Voice",

    MP4: "Vui lòng chọn video định dạng MP4",
    pngOrJpg: "Vui lòng tải lên ảnh định dạng PNG hoặc JPG",

    UploadingWait: "Đang tải lên, vui lòng đợi",
    CompleteInformation: "Vui lòng điền đầy đủ thông tin",
  },

  cancelAccount: {
    title: "Yêu cầu xóa tài khoản",
    tips: "Những thông tin sau sẽ bị xóa và không thể khôi phục",
    p1: "Tất cả thông tin tài khoản sẽ bị xóa vĩnh viễn (bao gồm theo dõi, fan, v.v.), các dịch vụ giá trị gia tăng đã mua sẽ không được giữ lại và không thể chuyển cho tài khoản khác (VIP, ID đẹp, khung avatar, v.v.)",
    p2: "Tài khoản Facebook, Twitter, Apple, Google đã liên kết sẽ bị hủy liên kết, có thể đăng ký lại sau khi hủy liên kết",
    p3: "Thông tin streamer của bạn sẽ bị hủy liên kết, có thể liên kết lại với tài khoản khác sau khi hủy liên kết (nếu bạn là streamer, thông tin streamer có thể xác thực lại để phát sóng)",
    p4: "Sau khi xóa tài khoản, số dư xu, kim cương, điểm kinh nghiệm, xe, quý tộc và các dữ liệu thu nhập khác sẽ bị xóa, nếu phát sinh tổn thất lợi ích, người yêu cầu xóa tài khoản sẽ chịu trách nhiệm",
    p5: "Nếu bạn là trưởng guild, guild sẽ tự động giải tán sau khi gửi yêu cầu xóa tài khoản (không thể khôi phục guild sau khi giải tán dù hủy yêu cầu); nếu bạn là thành viên guild, bạn sẽ tự động rời guild sau khi xóa tài khoản (có thể khôi phục nếu hủy xóa trong thời gian khiếu nại 15 ngày)",
    p6: "Nếu bạn là trưởng gia tộc, bạn cần giải tán hoặc rời gia tộc trước khi gửi yêu cầu xóa tài khoản;",
    p7: "Nếu bạn là thành viên gia tộc (không phải trưởng), bạn sẽ tự động rời gia tộc khi gửi yêu cầu xóa tài khoản (không thể khôi phục nếu hủy xóa trong thời gian khiếu nại 15 ngày)",
    p8: "Sau khi gửi yêu cầu xóa, có thời gian khiếu nại 15 ngày. Đăng nhập trong thời gian này sẽ tự động hủy xóa. Sau khi hết hạn khiếu nại, tài khoản sẽ tự động bị xóa và không thể khôi phục. Nếu trong thời gian này có lý do như không phải bản thân hoặc thao tác nhầm để khôi phục tài khoản, vui lòng liên hệ CSKH để khiếu nại. (WhatsApp CSKH: +62 81188011180, hoặc email: rainlive888@gmail.com)",
  },

  Proxy: {
    Hello: "Xin chào,",
    Welcome: "Chào mừng đến Rain Live!",
    Account: "Tài khoản",
    Pleaseenter: "Vui lòng nhập",
    Password: "Mật khẩu",
    Login: "Đăng nhập",
    MyAgent: "Đại lý của tôi",
    Nickname: "Biệt danh đại lý",
    CoinBalance: "Số dư xu đại lý",
    TransferRecord: "Lịch sử chuyển khoản",
    Recharge: "Nạp tiền",
    TransferInformation: "Vui lòng điền thông tin chuyển khoản",
    Reset: "Đặt lại",
    RecipientID: "ID người nhận",
    RecipientNickname: "Biệt danh người nhận",
    TransferAmount: "Số tiền chuyển",
    Transfer: "Chuyển khoản",
    KindReminder: "Nhắc nhở",
    DoubleCheck: "Vui lòng kiểm tra lại thông tin",
    SelectAmount: "Vui lòng chọn số tiền nạp",
    SelectMonth: "Chọn tháng",
    Username: "Tên người dùng",
    TransferTime: "Thời gian chuyển khoản",
    AutoFill: "Tự động điền",
    Rechargeselection: "Lựa chọn nạp tiền",
    ProxyCurrency: "Không đủ xu đại lý",
    PaymentAmount: "Số tiền thanh toán",
    PleaseSelectAmount: "Vui lòng chọn số tiền nạp",
  },

  bd: {
    incomeDetail: {
      title: "Chi tiết thu nhập",
      lastWeekIncome: "Thu nhập tuần trước",
      totalIncome: "Tổng thu nhập lịch sử",
      guildId: "ID Guild",
      date: "Ngày",
      thisWeek: "Tuần này",
      lastWeek: "Tuần trước",
      beforeLastWeek: "Tuần trước nữa",
      thisMonth: "Tháng này",
      lastMonth: "Tháng trước",
      summary: "Tổng hợp",
      guildName: "Tên guild",
      guildIncome: "Thu nhập guild",
      effectiveLive: "Phát sóng hiệu quả",
      myIncome: "Thu nhập của tôi",
      noData: "Không có dữ liệu",
      searching: "Tìm kiếm dữ liệu thu nhập",
      showingSummary: "Hiển thị dữ liệu tổng hợp",
    },
    index: {
      title: "BD",
      guildCount: "Số lượng guild",
      weekEstimatedIncome: "Thu nhập dự kiến tuần này",
      lastWeekIncome: "Thu nhập tuần trước",
      inviteCode: "Mã mời",
      searchPlaceholder: "Vui lòng nhập ID guild",
      lastWeek: "Tuần trước",
      guildName: "Tên guild",
      guildId: "ID Guild",
      weekIncome: "Thu nhập guild tuần này",
      myIncome: "Thu nhập của tôi",
      effectiveLive: "Phát sóng hiệu quả",
      bindDays: "Số ngày liên kết",
      copySuccess: "Đã sao chép mã mời",
      enterGuildId: "Vui lòng nhập ID guild",
      searchGuild: "Tìm kiếm ID guild",
      search: "Tìm kiếm",
      summary: "Tổng hợp",
      selectWeek: "Chọn chu kỳ",
      loading: "Đang tải...",
      loadFailed: "Tải thất bại",
      networkError: "Lỗi mạng, vui lòng thử lại sau",
    },
  },

  noble: {
    expireTime: "Thời gian hết hạn",
    canReceive: "Có thể nhận {coin} xu",
    receive: "Nhận ngay",
    received: "Đã nhận",
    becomeNoble: "Trở thành quý tộc",
    totalCanGet: "Tổng cộng có thể nhận {price}{totalCoin} xu",
    silver: "Bạc",
    gold: "Vàng",
    platinum: "Bạch kim",
    diamond: "Kim cương",
    obsidian: "Obsidian",
    privileges: {
      getCoin: "Nhận xu",
      avatarFrame: "Khung avatar",
      medal: "Huy hiệu",
      vehicle: "Phương tiện",
      purchaseNotification: "Thông báo mua",
      chatBubble: "Bong bóng chat",
      colorfulNickname: "Biệt danh màu sắc",
      specialId: "ID đặc biệt",
      mystery: "Người bí ẩn",
      exclusiveService: "Dịch vụ độc quyền",
      title: "Đặc quyền độc quyền",
      Effect: "Hiệu Ứng Vào Phòng",
    },
    receiveSuccess: "Nhận thành công",
    contactOperation: "Vui lòng liên hệ vận hành để nhận",
    level1Recharge: "Quý tộc Bạc /30 ngày",
    level2Recharge: "Quý tộc Vàng /30 ngày",
    level3Recharge: "Quý tộc Bạch kim /30 ngày",
    level4Recharge: "Quý tộc Kim cương /30 ngày",
    level5Recharge: "Quý tộc Obsidian /30 ngày",
  },

  bonusActivity: {
    title: "Phần thưởng phát sóng bổ sung",
    activityTime: "Thời gian hoạt động: 7/4/2025 đến 4/5/2025 (UTC+8)",
    rewardRules: "Quy tắc phần thưởng",
    reward: "Phần thưởng",
    totalReceived: "Tổng đã nhận",
    bonus: "Tiền thưởng",
    claim: "Nhận",
    claimed: "Đã nhận",
    notAchieved: "Chưa đạt",
    duration: "Thời lượng (giờ)",
    target: "Mục tiêu (xu)",
    note: "Lưu ý: Sau khi đạt mục tiêu, tiền thưởng có thể nhận vào ngày hôm sau",
    activityCalendar: "Lịch hoạt động",
    april: "Tháng 4",
    may: "Tháng 5",
    claimSuccess: "Nhận thành công",
  },

  bonusActivityRule: {
    activityDescription: "Mô tả hoạt động",
    descriptionContent:
      "Ngoài phần thưởng cơ bản, người phát sóng sẽ nhận được phần thưởng bổ sung từ Rain Live.",
    activityTime: "Thời gian hoạt động",
    timeContent1: "7/4/2025 đến 4/5/2025 (UTC+8)",
    timeContent2:
      "Vào 0 giờ (UTC+8) mỗi ngày, phần thưởng của ngày tiếp theo sẽ được mở",
    claimMethod: "Phương thức nhận",
    claimContent:
      "Khi đạt mục tiêu trong ngày, có thể nhận thưởng thủ công vào ngày hôm sau.",
    rewardTable: "Bảng phần thưởng:",
    targetTurnover: "Mục tiêu doanh thu",
    activityReward: "Phần thưởng hoạt động",
  },

  inviteFriends: {
    invitationEventTitle: "Sự kiện mời",
    inviteAndEarnRewards: "Mời và nhận thưởng",
    eventPeriod: "Thời gian hoạt động: 7/4 00:00 - 4/5 23:59:59 (UTC+8)",
    invitationRecord: "Lịch sử mời",
    eventDetails: "Chi tiết sự kiện",
    week1DateRange: "Tuần 1: 7/4-13/4",
    totalInvitedExample: "Số người đã mời",
    level1RewardText: "Lv.1 Mời 20 người                   20000 xu",
    level2RewardText: "Lv.2 Mời 50 người                   50000 xu",
    level3RewardText: "Lv.3 Mời 100 người                 100000 xu",
    statusClaimed: "Đã nhận",
    actionClaim: "Nhận",
    statusNotAchieved: "Chưa đạt",
    topUpRewardsLabel: "Phần thưởng nạp tiền:",
    copyInvitationLink: "Sao chép liên kết mời",
    rewardNote:
      "Lưu ý: Khi người được mời nạp tiền, bạn sẽ nhận được 2% số xu tương ứng.",
    copySuccess: "Sao chép thành công",
    claimSuccessExample: "Nhận thành công 20000 xu",
    userIDLabel: "ID người dùng",
    userNameLabel: "Tên người dùng",
    timeLabel: "Thời gian",
    topUpLabel: "Nạp tiền",
    eventPurposeTitle: "【Mục đích sự kiện】",
    eventPurposeDesc:
      "Để cảm ơn sự ủng hộ và yêu thích lâu dài của người dùng dành cho Rain Live, nền tảng đặc biệt ra mắt sự kiện 'Mời bạn bè - Nhận nhiều quà tặng', mời bạn cùng bạn bè chia sẻ trải nghiệm phát sóng trực tiếp thú vị!",
    eventDurationTitle: "【Thời gian sự kiện】",
    eventDateRange: "7/4/2025 đến tháng 5/2025",
    eventCycleDesc:
      "Tổng cộng 4 tuần, phần thưởng chu kỳ mới sẽ mở vào 0 giờ (UTC+8) mỗi thứ Hai",
    rewardRulesTitle: "【Quy tắc phần thưởng】",
    rewardRulesDesc1:
      "Ngoài phần thưởng của sự kiện này, vẫn được hưởng phần thưởng mời ban đầu:",
    rewardRulesDesc2:
      "2% số xu nạp của người dùng sẽ được thưởng thêm cho người mời.",
    importantNotesTitle: "【Lưu ý quan trọng】",
    importantNotesDesc:
      "⚠️ Nghiêm cấm các hành vi gian lận phần thưởng thông qua tài khoản giả, đăng ký bằng máy, v.v. Khi phát hiện, tất cả phần thưởng sẽ bị thu hồi ngay lập tức và có thể bị hạn chế chức năng tài khoản;",
  },
  bonusPoints: {
    activityTime: "Thời gian hoạt động",
    resetTime: "Đặt lại hàng ngày lúc 00:00 (UTC+8)",
    pointsReward: "Thưởng điểm",
    coinsReward: "Thưởng vàng",
    participationTimes: "Tham gia {times} lần",
    points: "Điểm",
    exchange: "Đổi",
    pointsMall: "Cửa hàng điểm",
    betSum: "Tổng cược hiện tại",
    note: "Ghi chú",
    rule1: "1.Điểm thu được khi hoàn thành nhiệm vụ hàng ngày.",
    rule2: "2.Phần thưởng trong trung tâm điểm thay đổi không định kỳ.",
    rule3: "3.Sau khi đổi, điểm không trả lại. Đổi cẩn thận.",
    coins: "Vàng",
    claim: "Nhận",
    claimed: "Đã nhận",
    notAchieved: "Chưa đạt",
    reach: "Đạt",
  },
  gameRanking: {
    notRanked: "Không Xếp Hạng",
    distanceToRank: "Còn thiếu {points} điểm để đạt xếp hạng 50",
    distanceToBeforeRank: "Còn thiếu {points} điểm để đạt xếp hạng {rankId}",
    rank1: "Bạn đã ở vị trí đầu tiên",
    rules: {
      pointsStats: {
        title: "Quy Tắc Thống Kê Điểm",
        conversion:
          "1. Tiêu Chuẩn Chuyển Đổi Điểm：1 đồng xu tương đương với 1 điểm trong hoạt động, và điểm của người tham gia sẽ được tính trực tiếp dựa trên số lượng đồng xu.",
        timeRange:
          "2. Khoảng Thời Gian Thống Kê：Chu kỳ thống kê điểm hàng ngày là 00:00 đến 23:59 (Múi Giờ UTC+8), dữ liệu đồng xu vượt quá khoảng thời gian này sẽ được đưa vào thống kê ngày hôm sau.",
      },
      ranking: {
        title: "Quy Tắc Xếp Hạng và Thưởng",
        basis:
          "3. Cơ Sở Xếp Hạng：Hệ thống sẽ xếp hạng người tham gia theo thứ tự giảm dần dựa trên tổng điểm cuối cùng hàng ngày của họ (tức là tổng số đồng xu trong ngày đó) để xác định xếp hạng hàng ngày.",
        rewards: "4. Cấu Hình Thưởng：",
        reward1: "Xếp hạng 1: Thưởng 250.000 đồng xu",
        reward2: "Xếp hạng 2: Thưởng 150.000 đồng xu",
        reward3: "Xếp hạng 3: Thưởng 100.000 đồng xu",
        reward4: "Xếp hạng 4: Thưởng 50.000 đồng xu",
        reward5: "Xếp hạng 5: Thưởng 50.000 đồng xu",
      },
      distribution: {
        title: "Quy Tắc Phát Thưởng",
        description:
          "Thưởng tương ứng với xếp hạng hàng ngày sẽ được phát một cách thống nhất vào ngày hôm sau. Người tham gia có thể đăng nhập vào trang hoạt động hoặc tài khoản cá nhân vào ngày hôm sau để kiểm tra trạng thái nhận thưởng.",
      },
      pointsCalculation: {
        description:
          "Doanh thu Game tối thiểu 5.000.000 là điều kiện cần thiết để nhận được phần thưởng của sự kiện.",
      },
      helpReward: {
        description:
          "Thưởng Bổ Sung: Nếu đáp ứng các yêu cầu tương ứng nhưng không nhận được thưởng xếp hạng, sẽ nhận được thưởng bổ sung.",
      },
      turnoverRewards: {
        title: "Quy Tắc Thưởng Doanh Thu",
        turnover: "Doanh Thu",
        reward: "Thưởng",
        turnover1M: "1,000,000",
        reward10K: "10,000 Đồng Xu",
        turnover3M: "3,000,000",
        reward30K: "30,000 Đồng Xu",
        turnover5M: "5,000,000",
        reward50K: "50,000 Đồng Xu",
      },
      violation: {
        title: "Quy Tắc Vi Phạm và Trừng Phạt",
        description:
          "Trong thời gian diễn ra hoạt động, nghiêm cấm người tham gia sử dụng lỗ hổng hệ thống, phần mềm gian lận hoặc bất kỳ phương tiện nào để gian lận bằng cách 刷取 (刷取) điểm (đồng xu). Nếu bị phát hiện:",
        penalty1:
          "5. Người vi phạm lần đầu sẽ bị thu hồi đủ điều kiện nhận thưởng trong ngày;",
        penalty2:
          "6. Người vi phạm với tình huống nghiêm trọng hoặc lặp đi lặp lại sẽ bị cấm trực tiếp tham gia hoạt động này và các hoạt động liên quan tiếp theo, và quyền tham gia sẽ không được khôi phục.",
      },
    },
  },
  luckyAnchorRanking: {
    today: "Hôm nay",
    yesterday: "Hôm qua",
    notRanked: "Chưa xếp hạng",
    distanceToRank: "Cần thêm {points} đậu may mắn để vào top 50",
    distanceToBeforeRank: "Cần thêm {points} đậu may mắn để đạt hạng {rankId}",
    rank1: "Bạn đã là hạng 1",
    rules: {
      activity: {
        title: "Mô tả hoạt động",
        description:
          "Thống kê thu nhập đậu may mắn hàng ngày của streamer và xếp hạng dựa trên thu nhập này.",
      },
      ranking: {
        title: "Phần thưởng xếp hạng",
        rank: "Hạng",
        reward: "Phần thưởng đậu",
        decoration: "Trang trí",
        frameAndBubble: "Khung avatar + Bong bóng",
        frameOnly: "Khung avatar",
        requirement:
          "Yêu cầu tối thiểu cho phần thưởng xếp hạng: 150,000 thu nhập đậu may mắn.",
      },
      helpReward: {
        title: "Phần thưởng hỗ trợ",
        description:
          "Người dùng không nhận được phần thưởng xếp hạng cũng có thể nhận phần thưởng mục tiêu thu nhập đậu may mắn.",
        target: "Mục tiêu",
        reward: "Phần thưởng",
      },
      distribution: {
        title: "Phân phối phần thưởng",
        description: "Phần thưởng sẽ được phân phối vào ngày hôm sau.",
      },
      statistics: {
        title: "Mô tả thống kê",
        description: "Thống kê dựa trên thu nhập đậu may mắn.",
      },
    },
  },

  // Hoạt động Red Envelope Rain
  redEnvelopeRain: {
    countdownTitle: "Đếm ngược nhận xu",
    startNow: "Bắt đầu ngay",
    rules: "Quy tắc",
    timeSlotPrize: "Giải thưởng tham gia theo khung giờ",
    winningDetails: "Chi tiết trúng thưởng",
    activityRules: "Quy tắc hoạt động",
    congratulations: "Chúc mừng bạn trúng thưởng",
    sorryNoWin: "Rất tiếc, bạn không trúng thưởng",
    coin: "Xu",
    rulesContent: {
      rule1:
        "i. Lì xì sẽ được mở đúng 20:00 mỗi ngày, sau đó cứ mỗi 20 phút lại diễn ra một lần.",
      rule2:
        "ii. Trước khi nhận lì xì, cần phát biểu 3 lần trong phòng livestream.",
      rule3: "iii. Thời gian diễn ra sự kiện: từ ngày 18/10 đến 17/11.",
      rule4:
        "iv. Nếu phát hiện hành vi cố tình lấy vàng bất hợp pháp, nền tảng sẽ tiến hành xử lý khóa tài khoản.",
      rule5: "",
    },
    timeStatus: {
      inProgress: "Đang diễn ra",
      notStarted: "Chưa bắt đầu",
      finished: "Đã kết thúc",
    },
    chatRequirement:
      "Gửi 3 tin nhắn trong phòng live để nhận, tin nhắn hiện tại: {count}",
  },

  // Hoạt động Guild
  guildActivity: {
    activityRules: "Quy tắc hoạt động",
    rulesContent: {
      activityTime: "Thời gian hoạt động: Bắt đầu từ 29/9",
      rankingRewards: "Phần thưởng xếp hạng",
      requirements: "Yêu cầu",
      rewardDistribution: "Phân phối phần thưởng",
      rewardList: {
        first: "Hạng 1: 1.000.000 Hạt Vàng",
        second: "Hạng 2: 500.000 Hạt Vàng",
        thirdToFifth: "Hạng 3-5: 250.000 Hạt Vàng",
      },
      requirementText:
        "Host guild phải hoàn thành ít nhất 30 buổi phát sóng trực tiếp mỗi tuần. Mỗi host phát sóng hơn 2 giờ mỗi ngày được tính là một buổi",
      distributionText: "Phần thưởng sẽ được phân phối vào tuần thứ hai",
    },
  },

  // Bảng xếp hạng sức hấp dẫn/Tiêu dùng
  charmRanking: {
    charmRanking: "Bảng Sức Hấp Dẫn",
    consumptionRanking: "Bảng Tiêu Dùng",
    dailyRanking: "Bảng Ngày",
    weeklyRanking: "Bảng Tuần",
    userNickname: "Tên người dùng",
    distanceToPrevious: "Khoảng cách đến người trước",
    noRankingData: "Không có dữ liệu xếp hạng",
    requestFailed: "Yêu cầu thất bại",
  },

  // Hoạt động mời bạn bè mới
  inviteActivity: {
    title: "Mời 3 người chắc chắn nhận được phần thưởng",
    rule: "Quy tắc",
    alreadyJoined: "Đã tham gia",
    inviteImmediately: "Mời ngay",
    callNumber: "Mời",
    myRewards: "Phần thưởng của tôi",
    claim: "Nhận",
    claimed: "Đã nhận",
    people: "Người",
    inviteFriends: "Mời bạn bè",
    processTitle: "Quy trình mời:",
    step1: "1. Gửi liên kết cho bạn bè",
    step2: "2. Bạn bè tải xuống và đăng ký",
    step3: "3. Nhận xu miễn phí",
    rulesTitle: "Quy tắc mời",
    rulesContent: {
      rule1: "Khi mời được 3 người, có thể nhận 16666 hạt vàng",
      rule2: "Khi mời được 25 người, có thể nhận thêm 36666 hạt vàng",
      rule3:
        "Khi mời được 100 người, có thể nhận thêm 88888 hạt vàng. Tổng có thể nhận: 142220 hạt vàng.",
      rule4: "Phần thưởng được nhận thủ công tại trang hoạt động.",
      rule5:
        "Nghiêm cấm gian lận số lượng người mời, nếu phát hiện sẽ bị khóa tài khoản",
    },
    close: "Đóng",
    inviteFeatureComingSoon: "Tính năng mời sẽ sớm có sẵn",
    rewardReceived: "Đã nhận thành công {amount} xu!",
  },

  // Trang Tặng Xu Vàng
  giftGoldCoins: {
    maxGiftableCoins: "Số Xu Vàng Tối Đa Có Thể Tặng",
    giftAmount: "Số Lượng Xu Vàng Tặng",
    customAmount: "Số Lượng Xu Vàng Tặng Tùy Chỉnh",
    enterAmount: "Nhập số lượng",
    quantity: "Số lượng",
    giftToOtherAccounts: "Tặng cho Tài Khoản Khác",
    exceedMaxAmount: "Số lượng không được vượt quá mức tối đa có thể tặng",
    amountSet: "Đã đặt số lượng thành công",
    invalidAmount: "Vui lòng nhập số lượng hợp lệ",
    selectValidAmount: "Vui lòng chọn số lượng hợp lệ",
    confirmTitle: "Xác Nhận Tặng",
    confirmMessage: "Bạn có chắc chắn muốn tặng {amount} xu không?",
    giftSuccess: "Tặng thành công",
    giftId: "ID Tặng",
    enterGiftId: "Nhập ID",
    pleaseEnterGiftId: "Vui lòng nhập ID tặng",
    giftCompleted: "Tặng thành công!",
    giftedToId: "Tặng cho ID",
    networkError: "Lỗi mạng, vui lòng thử lại sau",
    confirm: "Xác Nhận",
  },

  // Cửa hàng trang trí
  shop: {
    headerTitle: "Trang trí cá nhân",
    back: "Quay lại",
    shoppingBag: "Túi mua sắm",
    loading: "Đang tải...",
    noProducts: "Không có sản phẩm",
    unnamedProduct: "Sản phẩm chưa đặt tên",
    day: "Ngày",
    myCoins: "Xu của tôi",
    exchangeNow: "Đổi ngay",
    notSelected: "Chưa chọn",
    loginExpired: "Đăng nhập hết hạn, vui lòng đăng nhập lại",
    categoryNotExists: "Danh mục không tồn tại",
    loadFailed: "Tải thất bại",
    loadFailedRetry: "Tải thất bại, vui lòng thử lại",
    pleaseSelectProduct: "Vui lòng chọn sản phẩm trước",
    productNotExists: "Sản phẩm không tồn tại",
    insufficientCoins: "Xu không đủ, cần {amount} xu",
    exchangeSuccess: "Đổi thành công",
    exchangeFailed: "Đổi thất bại",
    categories: {
      hot: "Nổi bật",
      avatarFrame: "Khung avatar",
      entryEffect: "Hiệu ứng vào",
      chatBubble: "Bong bóng chat",
      mount: "Phương tiện",
    },
    recharge: "Nạp tiền >",
    validityPeriod: "Thời hạn:",
    myCoinsLabel: "Xu của tôi:",
  },
  myDecoration: {
    headerTitle: "Trang trí của tôi",
    back: "Quay lại",
    noWearingDecoration: "Không có trang trí nào được chọn",
    loading: "Đang tải...",
    noDecoration: "Không có trang trí",
    unnamedDecoration: "Trang trí chưa đặt tên",
    permanent: "Vĩnh viễn",
    wearing: "Đang sử dụng",
    pleaseSelectDecoration: "Vui lòng chọn trang trí",
    removeDecoration: "Gỡ trang trí",
    wearNow: "Sử dụng ngay",
    pleaseSelectDecorationFirst: "Vui lòng chọn trang trí trước",
    decorationNotExists: "Trang trí không tồn tại",
    loginExpired: "Đăng nhập hết hạn, vui lòng đăng nhập lại",
    loadFailed: "Tải thất bại",
    loadFailedRetry: "Tải thất bại, vui lòng thử lại",
    wearSuccess: "Sử dụng thành công",
    wearFailed: "Sử dụng thất bại",
    categories: {
      avatarFrame: "Khung avatar",
      entryEffect: "Hiệu ứng vào",
      chatBubble: "Bong bóng chat",
      mount: "Phương tiện",
    },
  },
  // Hoạt động Giáng sinh/Ngôi sao may mắn
  christmasActivity: {
    dailyLuckyStar: "Ngôi sao may mắn ngày",
    weeklyLuckyStar: "Ngôi sao may mắn tuần",
    startTime: "Thời gian bắt đầu:",
    obtainedCount: "Số lượng nhận được",
    moreChance: "Càng nhiều, càng lớn cơ hội",
    participated: "Met",
    notParticipated: "Unmet",
    historyRecord: "Lịch sử",
    myRecord: "Lịch sử của tôi",
    noRecord: "Không có lịch sử",
    loading: "Đang tải...",
    noMore: "Không còn nữa",
    coin: "Xu",
    goldCoin: "Vàng",
    unit: "cái",
    notWon: "Chưa trúng thưởng",
    conditionNotMet: "Điều kiện chưa đáp ứng",
    claimSuccess: "Nhận thành công",
    getRecordFailed: "Lấy lịch sử thất bại",
    rules: {
      title: "Quy định hoạt động",
      rule1: "Ngôi sao may mắn ngày",
      rule2:
        "Hoạt động Ngôi sao may mắn ngày, tất cả người dùng đều có thể tham gia",
      rule3:
        "Khi tặng quà tương ứng cho tươi, số lượng quà tặng sẽ được bằng dẫn, khi sử làng quê tông đạt yêu cầu, người dùng có thể tham gia mà & ai quay thong, mỗi lần sẽ có nghĩời may mắn nhận được phần thường xu vùng",
      rule4: "Số lượng quả bịng càng nhiều thì cơ hội trúng thường căng cao",
      rule5: "Ngôi sao may mắn tuần",
      rule6: "Hoạt động Ngôi sao mày màn tuân, tất cả khởi đầu có thể tham gia",
      rule7:
        "Khi nhịn được quả tương ứng do người dùng tụng, số lượng quân sự được cộng đồn, khi số lượng qua nhịn được địt yêu cầu, đợi có thì tham gần mẹ là xi Ngôi sao may min tuần, mài lần sự nó người may mẫn nhịn được phần thương",
      rule8:
        "Số lượng quà nhân được công nhiều thì cơ hội trúng thường công của",
      rule9: "Quy định khác",
      rule10: "Chương trình ăn này là đợt tri ân phúc lợi lớn",
      rule11: "Chỉ áp dụng cộng dồn khi tông qua cho khọi khác",
      rule12: "Nghiêm cấm m dang",
      rule13:
        "Phần thường sẽ được tự động phát theo từng khung giờ, có thể kiểm tra lịch sử trùng thường để biết kết quả",
    },
  },
  // Hoạt động Xếp hạng Điểm Ngôi sao May mắn
  fortuneStarActivity: {
    points: "Điểm",
    pointsRanking: "Xếp hạng Điểm",
    currentRoundPoints: "Điểm Vòng này",
    lastRoundPoints: "Điểm Vòng trước",
    defaultUserName: "Tên Người dùng",
    noData: "Không có dữ liệu",
    activityRules: "Quy tắc",
    historyRecord: "Lịch sử",
    earnedPoints: "Điểm đã nhận",
    participated: "Đã tham gia",
    notParticipated: "Chưa đáp ứng",
    myRecord: "Lịch sử của tôi",
    userId: "ID",
    userNickname: "Tên người dùng",
    sessionTime: "Thời gian phiên",
    winningStatus: "Tình trạng trúng thưởng",
    won: "Đã trúng thưởng",
    notWon: "Chưa trúng thưởng",
    rules: {
      rule1:
        "Trong thời gian sự kiện, người dùng có thể kiếm điểm bằng cách gửi quà tặng được chỉ định",
      rule2:
        "Điểm được tích lũy theo thời gian thực, kiểm tra xếp hạng điểm hiện tại",
      rule3:
        "Sau khi sự kiện kết thúc, người dùng xếp hạng cao sẽ nhận được phần thưởng hậu hĩnh",
      rule4:
        "Nghiêm cấm sử dụng bất kỳ thủ đoạn gian lận nào để kiếm điểm, người vi phạm sẽ bị hủy tư cách",
      rule5: "Nền tảng giữ quyền giải thích cuối cùng",
    },
  },

  // Hoạt động Hộp Bí Mật
  blindBox: {
    title: "Giới thiệu cách chơi",
    ruleTitle: "Giới thiệu cách chơi",
    rule1:
      "Mỗi {price} xu vàng có thể mở 1 {text}, sau khi mở, người chơi sẽ nhận ngẫu nhiên các loại quà tặng khác nhau, quà sẽ tự động được đưa vào túi.",
    rule2:
      "Có thể lấy quà nhận được từ trong túi tặng cho streamer mong muốn, streamer sẽ nhận được số đậu vàng tương ứng với quà đó",
    rewardTip: "Gợi ý phần thưởng",
    probabilityDesc: "Xác suất cụ thể như sau:",
    prize: "Phần thưởng",
    probability: "Xác suất",
    value: "Giá trị",
  },
  pcOfficial: {
    navHome: "Trang chủ",
    navLive: "Phát trực tiếp",
    navGameHall: "Sảnh game",
    received: "đã nhận",
    heroTagline: "Nền tảng giải trí Web4 hàng đầu toàn cầu",
    heroTaglineSub:
      "Tương tác thời gian thực 24/7 cùng các streamer hàng đầu, trải nghiệm game blockchain đỉnh cao. Dựa trên công nghệ phi tập trung, đảm bảo thưởng tức thì cho từng giao dịch, công bằng và minh bạch.",
    downloadNow: "Tải ngay",
    giftCoin: "Xu EX",
    giftAvatarFrame: "Avatar",
    bottomDownloadAndroidApk: "Android APK",
    recommendTitle: "Đề xuất streamer nổi bật",
    recommendSub:
      "Tương tác thời gian thực với hàng nghìn streamer và tận hưởng sức hút game P2E",
    hotGamingTitle: "Game nổi bật",
    hotGamingSub:
      "Người chơi thật, bảng xếp hạng thật. Bạn có trở thành huyền thoại tiếp theo không?",
    casinoTitle: "Sòng bài",
    casinoDesc1: "Tham gia cùng dealer thật với Baccarat,",
    casinoDesc2: "Roulette và Blackjack chuẩn HD",
    slotsTitle: "Slot",
    slotsDesc: "Trải nghiệm hàng trăm game slot chất lượng cao với RTP 98.5%",
    gamingTitle: "Game",
    gamingDesc: "Không chỉ quay thưởng, còn có game kỹ năng nhiều người chơi",
    whyTitle: "Vì sao chọn Rain Live",
    whyItem1Title: "Công bằng & minh bạch",
    whyItem1Desc: "RNG được kiểm định, đảm bảo tính công bằng",
    whyItem2Title: "Thanh toán tức thì",
    whyItem2Desc: "Rút tiền nhanh, nhận thưởng tức thời",
    whyItem3Title: "Ẩn danh & riêng tư",
    whyItem3Desc: "Bảo mật 100%, không yêu cầu thông tin cá nhân",
    whyItem4Title: "Phi tập trung",
    whyItem4Desc: "Trò chơi on-chain an toàn, minh bạch",
    terms: "Điều khoản dịch vụ",
    privacy: "Chính sách quyền riêng tư",
    navRecharge: "Nạp tiền",
    rechargeAccountTitle: "Tài khoản nạp",
    idLogin: "Đăng nhập ID",
    accountIdLabel: "ID tài khoản:",
    accountIdPlaceholder: "Nhập ID tài khoản",
    confirm: "Xác nhận",
    defaultUserName: "Tên người dùng",
    userIdWithValue: "ID:{id}",
    switchAccount: "Đổi tài khoản",
    rechargeQuantityTitle: "Số lượng nạp",
    goToPay: "Thanh toán",
    topUpAmountTitle: "Số tiền nạp",
    pay: "Thanh toán",
    channelDefault: "Kênh thanh toán",
    toastInvalidAccountId: "Vui lòng nhập ID tài khoản hợp lệ",
    toastNoTokenAfterLogin: "Đăng nhập thành công nhưng không nhận được token",
    toastLoginFailed: "Đăng nhập thất bại",
    toastCoinPackagesFailed: "Không tải được danh sách gói xu",
    toastPayChannelsFailed: "Không tải được kênh thanh toán",
    toastOrderParamsMissing: "Thiếu tham số đơn hàng, không thể thanh toán",
    toastNoPayUrl: "Không có địa chỉ thanh toán",
    toastCreateOrderFailed: "Tạo đơn thanh toán thất bại",
    rainLiveRecharge: "Rain Live Nạp tiền",
    selectCountryTitle: "Chọn quốc gia / khu vực",
    selectChannelTitle: "Chọn phương thức thanh toán",
    rechargeLoading: "Đang tải...",
    rechargePackagesEmpty: "Chưa có gói nạp",
    rechargeLoginHint: "Vui lòng đăng nhập bằng ID trước",
  },
};
